<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'日期'">
              <a-range-picker v-model='queryParam.sendTime' format='YYYY-MM-DD' style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item :label="'主产品'">
              <a-select mode='multiple' v-model='queryParam.mainAppSsids' :max-tag-count="2">
                <a-select-option v-for='item in mainAppList' :key='item.appssid' :value='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            <a-button type='primary' @click="downLoadData()" icon='download' style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
          </a-col>
        </a-row>
      </a-form>

      <!-- 主表格：用 index 做 key，彻底杜绝重复 -->
      <a-table
        ref='table'
        row-key="index"
        size='middle'
        :columns='columns'
        :dataSource='dataSource.map((item,index)=>({...item,index}))'
        :pagination='false'
        :loading='loading'
        bordered
        :scroll="{ x: 'max-content' }"
      />
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getRepayNotLoanProductInfo, getApplistExcludingSubApp } from '@/webpublicapi/order'
import moment from 'moment'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  name: 'SmsChannelstatistics',
  data() {
    return {
      I18N_KEY,
      mainAppList: [],
      remarksList: [],
      sum: {},
      form: { pageNum: 1, pageSize: 10 },
      total: 0,
      dataSource: [],
      queryParam: { tradeType: null, sendTime: [], mainAppSsids: [] },
      loading: false
    }
  },
  computed: {
    columns() {
      return [
        { title: '日期', align: 'center', dataIndex: 'date' },
        { title: '盘号', align: 'center', dataIndex: 'appSsid' },
        { title: '主产品首贷还款数', align: 'center', dataIndex: 'mainFirstLoanRepayNum' },
        { title: '主产品复贷申请数', align: 'center', dataIndex: 'mainRepaymentLoanApplyNum' },
        { title: '主产品复贷申请率', align: 'center', dataIndex: 'mainRepaymentLoanApplyRate' },
        { title: '主产品复贷通过数', align: 'center', dataIndex: 'mainRepaymentLoanPassNum' },
        { title: '主产品复贷通过率', align: 'center', dataIndex: 'mainRepaymentLoanPassRate' },
        { 
          title: '主产品首贷数', 
          align: 'center',
          children: [
            {
              title: '子产品01',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub01FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub01FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub01FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub01FirstLoanPassRate' }
              ]
            },
            {
              title: '子产品02',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub02FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub02FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub02FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub02FirstLoanPassRate' }
              ]
            },
            {
              title: '子产品03',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub03FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub03FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub03FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub03FirstLoanPassRate' }
              ]
            },
            {
              title: '子产品04',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub04FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub04FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub04FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub04FirstLoanPassRate' }
              ]
            },
            {
              title: '子产品05',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub05FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub05FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub05FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub05FirstLoanPassRate' }
              ]
            },
            {
              title: '子产品06',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub06FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub06FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub06FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub06FirstLoanPassRate' }
              ]
            },
            {
              title: '子产品07',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub07FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub07FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub07FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub07FirstLoanPassRate' }
              ]
            },
            {
              title: '子产品08',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub08FirstLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub08FirstLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub08FirstLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub08FirstLoanPassRate' }
              ]
            }
          ]
        },
        { 
          title: '主产品复贷数', 
          align: 'center',
          children: [
            {
              title: '子产品01',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub01RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub01RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub01RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub01RepaymentLoanPassRate' }
              ]
            },
            {
              title: '子产品02',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub02RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub02RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub02RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub02RepaymentLoanPassRate' }
              ]
            },
            {
              title: '子产品03',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub03RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub03RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub03RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub03RepaymentLoanPassRate' }
              ]
            },
            {
              title: '子产品04',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub04RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub04RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub04RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub04RepaymentLoanPassRate' }
              ]
            },
            {
              title: '子产品05',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub05RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub05RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub05RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub05RepaymentLoanPassRate' }
              ]
            },
            {
              title: '子产品06',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub06RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub06RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub06RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub06RepaymentLoanPassRate' }
              ]
            },
            {
              title: '子产品07',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub07RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub07RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub07RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub07RepaymentLoanPassRate' }
              ]
            },
            {
              title: '子产品08',
              align: 'center',
              children: [
                { title: '申请数', align: 'center', dataIndex: 'sub08RepaymentLoanApplyNum' },
                { title: '申请率', align: 'center', dataIndex: 'sub08RepaymentLoanApplyRate' },
                { title: '通过数', align: 'center', dataIndex: 'sub08RepaymentLoanPassNum' },
                { title: '通过率', align: 'center', dataIndex: 'sub08RepaymentLoanPassRate' }
              ]
            }
          ]
        }
      ]
    }
  },
  created() {
    this.loadSelectData()
    this.loadData()
  },
  methods: {
    formatNumber(v) { return v == null ? 0 : Number(v).toLocaleString() },
    loadSelectData() {
      getApplistExcludingSubApp().then(res => res.data && (this.mainAppList = res.data))
      getRemarksList().then(res => res.data && (this.remarksList = res.data.map(s=>({remarks:s,appName:s}))))
    },
    searchQuery() { this.loadData() },
    loadData() {
      const p = this.getQueryParams()
      if (!p) return
      this.loading = true

      // 主列表
      getRepayNotLoanProductInfo(p).then(res => {
        try {
          if (res.code === 1000) {
            this.dataSource = res.data.rows || []
            // this.total = res.data.total || 0
            this.$message.success(res.msg)
          } else {
            this.$message.info(res.msg)
          }
        } catch (error) {
          this.$message.error(error.msg)
        } finally {
          this.loading = false;
        }
        
      })
    },
    transformTime: t => moment(t).format('YYYY-MM-DD'),
    getQueryParams() {
      const { sendTime } = this.queryParam
      const d = {
        ...this.queryParam,
        settleStartTime: sendTime?.length ? this.transformTime(sendTime[0]) : null,
        settleEndTime: sendTime?.length ? this.transformTime(sendTime[1]) : null
      }
      delete d.sendTime
      return filterObj(d)
    },
    async downLoadData() {
      const p = this.getQueryParams()
      delete p.pageNum; delete p.pageSize
      this.loading = true
      try { await exportFileByPost('/api/web/webpublic/repayNotLoan/excel', p, "产品复贷详情报表.xlsx") }
      catch (e) { this.$message.error(e.message) }
      finally { this.loading = false }
    },
    handleTableChange(pn, ps) { this.form.pageNum = pn; this.form.pageSize = ps; this.loadData() },
    searchReset() {
      this.queryParam = { sendTime: [], mainAppSsids: [] }
      this.form = { pageNum: 1, pageSize: 10 }
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>